<template>
  <div :class="className" :style="{height:height,width:width,margin:margin}"/>
</template>

<script>
import resize from '@/mixin/resize'

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '260px'
    },
    margin: {
      type: String,
      default: '0'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart() {
      this.chart = this.$echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData)
    },
    setOptions(chartData) {
      const seriesData = chartData.v_92740008.map(item => {
        if (item.detailKey == ('其他')) {
          item.detailKey = this.$t('others');
        }
        return {
          name: item.detailKey,
          value: item.detailValue
        }
      })
      this.chart.setOption({
        tooltip: {
          trigger: 'item'
        },
        legend: {
          top: 'middle',
          right: 40,
          orient: 'vertical'
        },
        series: [
          {
            name: this.$t('employeeAgeRatioStatistics.seriesName'),
            type: 'pie',
            selectedMode: 'single',
            width: 240,
            height: 240,
            top: 'middle',
            left: 70,
            radius: ['0%', '80%'],
            itemStyle: {
              borderColor: '#FFFFFF',
              borderWidth: 1
            },
            label: {
              width: 100,
              formatter: '{b}\n{d}%'
            },
            emphasis: {},
            labelLine: {
              show: true,
              lineStyle: {
                type: 'dashed'
              }
            },
            data: seriesData
          }
        ]
      })
    }
  }
}
</script>
